export function resolveApiUrl(path) {
  const basePath = process.env.REACT_APP_API_URL;
  let prefix = new URL(basePath).pathname;
  if (prefix.endsWith("/")) prefix = prefix.slice(0, -1);

  return new URL(prefix + path, basePath);
}
